import { graphql } from 'gql';

export const bimPriceTableDataAnalyticsGql = graphql(`
    query bimPriceRowAnalytics(
        $workOrderPriceId: Long!
        $refWorkOrderPriceId: Long!
        $priceLevel: BimPriceLevelEnum
        $where: BimPriceAnalyticsItemFilterInput
        $take: Int
    ) {
        bimPriceRowAnalytics(
            workOrderPriceId: $workOrderPriceId
            refWorkOrderPriceId: $refWorkOrderPriceId
            priceLevel: $priceLevel
            where: $where
            take: $take
        ) {
            totalCount
            items {
                section {
                    sysId
                    order
                    status
                    topHeaderValue {
                        name
                    }
                    refHeaderValue {
                        name
                    }
                    changedProperties
                }
                subsection {
                    sysId
                    order
                    status
                    topHeaderValue {
                        name
                    }
                    refHeaderValue {
                        name
                    }
                    changedProperties
                }
                price {
                    sysId
                    order
                    status
                    topPriceValue {
                        code
                        name
                        emm
                        mp
                        mz
                        name
                        nr
                        op
                        others
                        oz
                        ozp
                        quantity
                        smrTotal
                        sp
                        total
                        tzr
                        unit
                        unitCost
                        zpm
                    }
                    refPriceValue {
                        code
                        name
                        emm
                        mp
                        mz
                        name
                        nr
                        op
                        others
                        oz
                        ozp
                        quantity
                        smrTotal
                        sp
                        total
                        tzr
                        unit
                        unitCost
                        zpm
                    }
                    changedProperties
                }
            }
        }
    }
`);

export const bimPriceBaseAnalyticsGql = graphql(`
    query bimPriceAnalytics($workOrderPriceId: Long!, $refWorkOrderPriceId: Long!, $priceLevel: BimPriceLevelEnum) {
        bimPriceAnalytics(
            workOrderPriceId: $workOrderPriceId
            refWorkOrderPriceId: $refWorkOrderPriceId
            priceLevel: $priceLevel
        ) {
            result
            message
            data {
                topPriceId
                refPriceId
                topPriceValue {
                    code
                    name
                    emm
                    mp
                    mz
                    name
                    nr
                    op
                    others
                    oz
                    ozp
                    quantity
                    smrTotal
                    sp
                    total
                    tzr
                    unit
                    unitCost
                    zpm
                }
                refPriceValue {
                    code
                    name
                    emm
                    mp
                    mz
                    name
                    nr
                    op
                    others
                    oz
                    ozp
                    quantity
                    smrTotal
                    sp
                    total
                    tzr
                    unit
                    unitCost
                    zpm
                }
                statusCounts {
                    status
                    count
                }
            }
        }
    }
`);

export const getPriceVersionsGql = graphql(`
    query bimWorkOrderPriceAnalyticsPriceVersions($workOrderPriceId: Long!) {
        bimWorkOrderPriceRevisions(workOrderPriceId: $workOrderPriceId) {
            items {
                id
                planValue {
                    code
                }
                isRevisionPrice
                isUpdatedPrice
                priceUpdateDate
            }
            totalCount
        }
    }
`);

export const bimPriceRowAnalyticsSectionFilterGql = graphql(`
    query bimPriceRowAnalyticsSectionFilter(
        $workOrderPriceId: Long!
        $refWorkOrderPriceId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        bimPriceRowAnalyticsSectionFilter(
            workOrderPriceId: $workOrderPriceId
            refWorkOrderPriceId: $refWorkOrderPriceId
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const bimPriceRowAnalyticsSubsectionFilterGql = graphql(`
    query bimPriceRowAnalyticsSubsectionFilter(
        $workOrderPriceId: Long!
        $refWorkOrderPriceId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        bimPriceRowAnalyticsSubsectionFilter(
            workOrderPriceId: $workOrderPriceId
            refWorkOrderPriceId: $refWorkOrderPriceId
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const bimPriceRowAnalyticsCodeFilterGql = graphql(`
    query bimPriceRowAnalyticsCodeFilter(
        $workOrderPriceId: Long!
        $refWorkOrderPriceId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        bimPriceRowAnalyticsCodeFilter(
            workOrderPriceId: $workOrderPriceId
            refWorkOrderPriceId: $refWorkOrderPriceId
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const bimPriceRowAnalyticsNameFilterGql = graphql(`
    query bimPriceRowAnalyticsNameFilter(
        $workOrderPriceId: Long!
        $refWorkOrderPriceId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        bimPriceRowAnalyticsNameFilter(
            workOrderPriceId: $workOrderPriceId
            refWorkOrderPriceId: $refWorkOrderPriceId
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const bimPriceRowAnalyticsUnitFilterGql = graphql(`
    query bimPriceRowAnalyticsUnitFilter(
        $workOrderPriceId: Long!
        $refWorkOrderPriceId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        bimPriceRowAnalyticsUnitFilter(
            workOrderPriceId: $workOrderPriceId
            refWorkOrderPriceId: $refWorkOrderPriceId
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);
